import Repository from './Repository'
import TokenService from '../helpers/token'
const resource = `${Repository.defaults.baseURL}`
export default {
  async provinces (params) {
    const response = await Repository.get(`${resource}/address`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async districts (params, provinceId) {
    const response = await Repository.get(`${resource}/address/${provinceId}`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async wards (params, provinceId, districtId) {
    const response = await Repository.get(`${resource}/address/${provinceId}/${districtId}`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async schools(params) {
    const response = await Repository.get(`${resource}/schools`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
}
